import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiClient } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { CheckCircle2, Loader2, AlertCircle, ArrowRight } from "lucide-react";

const MAX_POLLS = 8;

export default function PaymentSuccessPage() {
  const { lang } = useI18n();
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: null, amount: null });

  useEffect(() => {
    if (!session_id) {
      setState({ status: "error" });
      return;
    }
    let count = 0;
    const poll = async () => {
      try {
        const { data } = await apiClient.get(`/payments/status/${session_id}`);
        if (data.payment_status === "paid") {
          setState({ status: "paid", payment_status: data.payment_status, amount: data.amount_total, currency: data.currency, metadata: data.metadata });
          return;
        }
        if (data.status === "expired") {
          setState({ status: "expired" });
          return;
        }
        count++;
        if (count >= MAX_POLLS) {
          setState({ status: "timeout" });
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setState({ status: "error" });
      }
    };
    poll();
  }, [session_id]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24" data-testid="payment-success-page">
      <div className="surface rounded-3xl p-10 text-center">
        {state.status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-[#8a6f2e] animate-spin mx-auto" />
            <h1 className="font-display text-2xl mt-4">{lang === "ar" ? "جاري التحقق من الدفع…" : "Confirming your payment…"}</h1>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-[#8a6f2e] mx-auto" />
            <h1 className="font-display text-3xl mt-4">{lang === "ar" ? "تم الدفع بنجاح" : "Payment successful"}</h1>
            <p className="text-[#525252] mt-2">{lang === "ar" ? "شكراً لانضمامك إلى كارتال." : "Thank you for joining CARTAL."}</p>
            <div className="mt-3 text-[#8a6f2e] font-display text-2xl">{(state.amount / 100).toLocaleString()} {(state.currency || "sar").toUpperCase()}</div>
            <Link to="/dashboard" className="btn-primary mt-6 inline-flex">{lang === "ar" ? "إلى لوحة التحكم" : "Go to dashboard"} <ArrowRight className="w-4 h-4" /></Link>
          </>
        )}
        {["timeout", "expired", "error"].includes(state.status) && (
          <>
            <AlertCircle className="w-12 h-12 text-red-300 mx-auto" />
            <h1 className="font-display text-2xl mt-4">{lang === "ar" ? "تعذر تأكيد الدفع" : "We couldn't confirm your payment"}</h1>
            <p className="text-[#525252] mt-2">{lang === "ar" ? "حاول مرة أخرى أو تواصل مع الدعم." : "Please try again or contact support."}</p>
            <Link to="/pricing" className="btn-ghost mt-6 inline-flex">{lang === "ar" ? "العودة للباقات" : "Back to pricing"}</Link>
          </>
        )}
      </div>
    </div>
  );
}
